<template>
<section>
    <!--工具条-->
    <el-col :span="24" class="toolbar" style="padding-bottom: 0px;">
        <el-form :inline="true" :model="filters">
            <el-form-item>
                <el-select v-model="filters.servicerCode" placeholder="服务商名称" filterable clearable>
                    <el-option v-for="item in options_servicerman" :label="item.servicerName" :value="item.userid" v-bind:key="item.userid">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item>
                <el-date-picker v-model="filters.expireStartDate" type="date" placeholder="到期开始日期" :picker-options="pickerOptions0">
                </el-date-picker>
            </el-form-item>
            <el-form-item>
                <el-date-picker v-model="filters.expireEndDate" type="date" placeholder="到期截止日期" :picker-options="pickerOptions0">
                </el-date-picker>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" v-on:click="getCards">查询</el-button>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="exportExcel">导出EXCEL</el-button>
            </el-form-item>
        </el-form>
    </el-col>

    <!--列表-->
    <el-table :data="cards" highlight-current-row v-loading="listLoading" style="width: 100%;">
        <el-table-column prop="msisdn" label="卡号" width="150" sortable>
        </el-table-column>
        <el-table-column prop="iccid" label="ICCID" width="210" sortable>
        </el-table-column>
        <el-table-column prop="imsi" label="IMSI" width="180" sortable>
        </el-table-column>
        <el-table-column prop="querycode" label="查询代码" width="120" sortable>
        </el-table-column>
        <el-table-column prop="packagename" label="套餐名称" min-width="200" sortable>
        </el-table-column>
        <el-table-column prop="cardstate" label="卡状态" min-width="100" sortable>
        </el-table-column>
        <el-table-column prop="openAccountTime" label="开户时间" min-width="150" sortable>
        </el-table-column>
        <el-table-column prop="addtime" label="入库日期" min-width="120" sortable>
        </el-table-column>
        <el-table-column prop="outSkuDate" label="出库日期" min-width="120" sortable>
        </el-table-column>
        <el-table-column prop="activeDate" label="激活日期" min-width="120" sortable>
        </el-table-column>
        <el-table-column prop="expiretime" label="到期时间" min-width="150" sortable>
        </el-table-column>
        <el-table-column prop="servicername" label="服务商名称" min-width="180" sortable>
        </el-table-column>
        <el-table-column prop="contactmobile" label="联系人" min-width="180" sortable>
        </el-table-column>
        <el-table-column prop="currentmoney" label="用户余额" min-width="120" sortable>
        </el-table-column>
        <el-table-column prop="totalgprs" label="总流量" min-width="150" sortable>
        </el-table-column>
        <el-table-column prop="currentgprs" label="剩余流量" min-width="120" sortable>
        </el-table-column>
        <el-table-column prop="usedsmsnum" label="短信使用条数" min-width="150" sortable>
        </el-table-column>
        <el-table-column prop="remark" label="备注信息" min-width="150" sortable>
        </el-table-column>
        <el-table-column label="操作" width="235" fixed="right">
            <template scope="scope" v-if="sysUserName!=null">
                <template v-if="sysUserName=='管理员' || sysUserName=='一级服务商'">
                    <el-button size="small" @click="handleExpire(scope.$index, scope.row)">延期一年</el-button>
                    <el-button size="small" @click="handleMore(scope.$index, scope.row)">详细</el-button>
                    <el-button size="small" @click="showQrcode(scope.$index, scope.row)">二维码</el-button>
                </template>
                <template v-else>
                    <el-button size="small" @click="handleMore(scope.$index, scope.row)">详细</el-button>
                    <el-button size="small" @click="showQrcode(scope.$index, scope.row)">二维码</el-button>
                </template>
            </template>
        </el-table-column>
    </el-table>

    <!--工具条(分页)-->
    <el-col :span="24" class="toolbar">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage" :page-sizes="[10, 20, 50, 100]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper" :total="total" style="float:right;">
        </el-pagination>
    </el-col>

    <!--卡号信息详情界面-->
    <cardinfo ref="cardinfo"></cardinfo>
    <cardqrcode ref="cardqrcode"></cardqrcode>

</section>
</template>

<script>
import util from '../../common/js/util'
import constant from '../../common/js/constant'
//import NProgress from 'nprogress'
import {
    getCarListByExpire,
    editCardExpiretime,
    getChildUsers,
    getCardDetail,
    updateCardRemarkAndDate
} from '../../api/api';
import Cardinfo from '../../components/card_info.vue';
import CardQrcode from '../../components/card_qrcode.vue';

export default {
    components: {
        cardinfo: Cardinfo,
        cardqrcode: CardQrcode
    },
    data() {
        return {
            sysUserName: '',
            pickerOptions0: {
                disabledDate(time) {
                    return false;
                }
            },
            options_servicerman: [],
            filters: {
                servicerCode: '',
                expireStartDate: '',
                expireEndDate: ''
            },
            cards: [],
            total: 0, //列表总条数
            pageSize: 10, //每页条数
            currentPage: 1, //当前页码
            listLoading: false,
            editLoading: false
        }
    },
    methods: {
        exportExcel() {
            this.filters.expireStartDate = (!this.filters.expireStartDate || this.filters.expireStartDate == '') ? '' : util.formatDate.format(new Date(this.filters.expireStartDate), 'yyyy-MM-dd');
            this.filters.expireEndDate = (!this.filters.expireEndDate || this.filters.expireEndDate == '') ? '' : util.formatDate.format(new Date(this.filters.expireEndDate), 'yyyy-MM-dd');
            if (this.filters.expireStartDate == '' && this.filters.expireEndDate == '') {
                this.$message({
                    message: "必须先选择到期开始日期或到期截止日期任何一项！",
                    type: 'error'
                });
                this.cards = [];
                this.total = 0;
                this.pageSize = 10;
                this.currentPage = 1;
                return;
            }
            let para = "";
            para += "servicerCode=" + ((!this.filters.servicerCode || this.filters.servicerCode == '') ? '' : this.filters.servicerCode);
            para += "&expireStartDate=" + this.filters.expireStartDate;
            para += "&expireEndDate=" + this.filters.expireEndDate;
            location.href = "/api/cards/exportExpireXls?" + para;
        },
        handleSizeChange(val) {
            this.pageSize = val;
            this.getCards();
        },
        handleCurrentChange(val) {
            this.currentPage = val;
            this.getCards();
        },
        //获取卡号列表
        getCards() {
            this.filters.expireStartDate = (!this.filters.expireStartDate || this.filters.expireStartDate == '') ? '' : util.formatDate.format(new Date(this.filters.expireStartDate), 'yyyy-MM-dd');
            this.filters.expireEndDate = (!this.filters.expireEndDate || this.filters.expireEndDate == '') ? '' : util.formatDate.format(new Date(this.filters.expireEndDate), 'yyyy-MM-dd');
            if (this.filters.expireStartDate == '' && this.filters.expireEndDate == '') {
                this.$message({
                    message: "必须先选择到期开始日期或到期截止日期任何一项！",
                    type: 'error'
                });
                this.cards = [];
                this.total = 0;
                this.pageSize = 10;
                this.currentPage = 1;
                return;
            }
            let para = {
                pageSize: this.pageSize,
                pageNum: this.currentPage
            };
            para = Object.assign(para, this.filters);
            this.listLoading = true;
            //NProgress.start();
            getCarListByExpire(para).then((res) => {
                this.total = res.data.total;
                this.cards = res.data.list;
                this.listLoading = false;
                //NProgress.done();
            });
        },
        //显示卡号详细界面
        handleMore: function (index, row) {
            this.$refs.cardinfo.showCardDetail(row.msisdn);
        },
        //显示二维码界面
        showQrcode: function (index, row) {
            let price = parseFloat(row.rechargePrice);
            if (price <= 0) {
                this.$message({
                    message: "请先设置该物联网卡的充值价格！",
                    type: 'error'
                });
                return;
            } else {
                this.$refs.cardqrcode.showCardQrcode(row.iccid);
            }
        },
        //延期
        handleExpire: function (index, row) {
            this.$confirm('确认要为此卡延期一年有效期么?', '提示', {
                type: 'warning'
            }).then(() => {
                this.listLoading = true;
                //NProgress.start();
                let para = {
                    msisdn: row.msisdn
                };
                editCardExpiretime(para).then((res) => {
                    this.listLoading = false;
                    //NProgress.done();
                    this.$message({
                        message: '更新成功',
                        type: 'success'
                    });
                    this.getCards();
                });
            }).catch(() => {

            });
        }
    },
    mounted() {
        var user = sessionStorage.getItem('user');
        if (user) {
            user = JSON.parse(user);
        }

        let para = {};
        getChildUsers(para).then((res) => {
            this.editLoading = false;
            this.options_servicerman = res.data;
        });

        var now = new Date(); //当前日期 
        var nowMonth = now.getMonth(); //当前月 
        var nowYear = now.getFullYear(); //当前年 
        //本月的第一天
        this.filters.expireStartDate = new Date(nowYear, nowMonth, 1);
        //本月的最后一天
        this.filters.expireEndDate = new Date(nowYear, nowMonth + 1, 0);
        this.getCards();
    }
}
</script>



// WEBPACK FOOTER //
// expire_remind.vue?03781ccc